import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import { usePermission } from "../../../../context/PermissionContext";
import { capitalizeFirstLetter, getSaleTrack } from "./invoiceUtils";
import { FormatedSaleData } from "../../GlobelSaleData";
import DateConverter from "@heartinz/date_and_time_processor";
import axios from "axios";
import Messages from "../../../../constants/Messages";
import { useShowAlert } from "../../../../context/AlertContext";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../../../AxiosInstance";
import { useNetwork } from "../../../../context/NetworkContext";
import handleError from "../../../../constants/handleError";
import { useSaleContext } from "../../../../context/SaleContext";
import { useAuth } from "../../../../context/AuthProvider";
import { getOS } from "../../../getOs";
import uRLs from "../../../baseUtils";
import { handlePrint } from "../../SaleFunctions";
function InvoiceModalLayout({
  isOpen,
  data,
  selectedOption,
  selectedSize,
  setSelectedSize,
  selectTermalOption,
  isActive,
  isMainModalOpen,
  latestVersion,
  isBtnLoading,
  handleResetSale,

  handleModeConfirm,
  selectHALFA4Option,
  optData,

  onClose,
  children,
  displayCreatedTime,
  setDownload,
  setBilling,
  download,
  billing,
  generateInvoice1,
  generateBill1,
  returnTrack,
  isPreSale,
  isPurchase
}) {
  const { permission, storeSettings,blockedPermissions, viewOption, hasModulePermission } =
    usePermission();
  const { setPaymentModal, setSaleModalOpen } = useSaleContext();
  const globalData = FormatedSaleData(data);
    const [shareLoad, setShareLoad] = useState(false);
      const [print, setPrint] = useState(false);
  const [share, setShare] = useState(false);
  const [edit, setEdit] = useState(false);
   const [showConfirm, setShowConfirm] = useState(false);
  const showAlert = useShowAlert();
  const navigate = useNavigate();
  const { checkNetwork } = useNetwork();
  const { updateSettings } = useAuth();
  const selectedTheme = storeSettings.invoiceSettings?.template;
    const os = getOS()
   const printLock = useRef(false);
  const timezone = data?.saleby?.timezone;
  const isReturnHistory = Boolean(data?.returnSaleData?.returnTrack);
  const createdAt = data?.preSaleData?.createdAt || data?.createdAt;
  const isBillReceipt =
    globalData?.salemode?.toUpperCase() === "BILL" &&
    storeSettings?.saleSettings?.saleModeSettings?.isBill_isTax;
  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      case "PROFORMA_INVOICE":
      return "PROFORMA_INVOICE";
      default:
        return salemode;
    }
  };
  
  const createdTime =
    displayCreatedTime ||
    (createdAt
      ? DateConverter.ISOToDisplayFormat(
          DateConverter.convertToTimeZone(createdAt, timezone),
        )
      : "--:--");
  const isReturn = !!isReturnHistory || isPreSale;
;
  
  const sizeOptions = isReturn ||isPreSale
    ? [
        { key: "HALFA4", label: "A4 Half" },
        { key: "A4", label: "A4" },
      ]
    : isPurchase
      ? [{ key: "A4", label: "A4" }]
      : [
          { key: "2INCH", label: "2 Inch" },
          { key: "3INCH", label: "3 Inch" },
          { key: "4INCH", label: "4 Inch" },
          { key: "HALFA4", label: "A4 Half" },
          { key: "A4", label: "A4" },
        ];
   const handleDownload = async (data) => {
    setDownload(true);
    const salemode = data?.preSaleData?.preSaleMode || data?.salemode;
    const saleno = data?.preSaleData?.preSaleNo || data?.saleno || data?.saleReturnNo;
    const doc = isBillReceipt
      ? await generateInvoice1()
      : salemode?.toUpperCase() === "BILL"
        ? await generateBill1()
        : await generateInvoice1();

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };
  const generateToken = async (saleId) => {
    setShareLoad(true);
    try {
      const response = await AxiosInstance.post(`/module/sale/${saleId}`);

      const results = response.data.results;
      setShareLoad(false);
      return results;
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setShareLoad(false);
    }
  };

 
  const updatePrinterSetting = async (size) => {
    try {
      await AxiosInstance.patch("module/storesettings", {
        printerSettings: { paperSize: size },
      });
      updateSettings({
        storeSettings: {
          printerSettings: {
            paperSize: size,
          },
        },
      });
    } catch (error) {
      handleError(error, showAlert);
    }
  };
  const handleNormalShare = async (data, selectedOption) => {
    try {
      const shareToken = await generateToken(data?._id);

      const invoiceLink = `${uRLs.PUBLIC_PORTAL_URL}share/sale/?token=${shareToken}`;

      // Open in new tab
      window.open(invoiceLink, "_blank");
    } catch (error) {
      console.error("Error generating share link:", error);
    }
  };
  const handleWhappShare = async (data) => {
    try {
      // Create the dynamic invoice link
      const shareToken = await generateToken(data?._id);
      const invoiceLink = `${uRLs.PUBLIC_PORTAL_URL}share/sale/?token=${shareToken}`;

      // Create the message to share
      const message = `*${
        data.salefrom ? data?.salefrom?.title?.toUpperCase() : ""
      }*\nSale Receipt Sale No: *${
        data?.saleno
      }* \n\n_Click Link Below to Download :_\n${invoiceLink}\n\n---------------------\n${
        data?.saleitems && data.saleitems.length > 0
          ? data.saleitems
              .map((item, index) => {
                return `*S.No*: ${index + 1},\n*Description*: ${
                  item.title
                },\n*Qty*: ${item.quantity} ${(() => {
                  const unitCode = item?.isSecondaryUnit
                    ? item?.unitConfig?.secondaryUnitCode
                    : item?.unitConfig?.primaryUnitCode;
                  return unitCode || "";
                })()} ,${
                  item.discount > 0
                    ? `,\n*Price*: ~${item.mrp}~,\n*Discount*: ${item.discount}`
                    : ""
                },\n*Amount*: ${item.soldprice}`;
              })
              .join("\n---------------------\n")
          : "*No items found.*"
      }
          \n---------------------\n\nGrand Total : *${data?.grandtotal}*\n\n*Thank you for visiting Us*${
            storeSettings?.negobillBranding ? "\n_powered by negobill.com_" : ""
          }`;

      // Encode message for URL
      let whatsappUrl;

      if (data?.saleto?.phone) {
        const phoneNumber = data?.saleto?.phone.replace(/\D/g, "");
        whatsappUrl = `https://wa.me/${
          phoneNumber.startsWith("91") ? phoneNumber : `91${phoneNumber}`
        }?text=${encodeURIComponent(message)}`;
      } else {
        whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
      }

      window.open(whatsappUrl, "_blank");
    } catch (error) {
      console.error("Error sharing on WhatsApp:", error);
    }
  };
  const handlePrintService = async (pdfBase64, printerName) => {
    try {
      const response = await axios.post(
        "http://127.0.0.1:9164/print/pdf",
        {
          pdfBase64,
          printerName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };
  const handlePrintSystem = async (pdfBase64, printerName) => {
    if (
      os === "Windows" &&
      storeSettings?.printSystemSettings?.printThrough &&
      printerName
    ) {
      return await handlePrintService(pdfBase64, printerName);
    } else {
      setBilling(false);
    }
    return false;
  };

  useEffect(() => {
    const handleEnterPrint = async (event) => {
      if (!isActive || !isMainModalOpen) return;
      const tag = event.target.tagName;
      const isTyping =
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        tag === "SELECT" ||
        event.target.isContentEditable;
      if (isTyping) return;

      if (event.key === "Enter" && !printLock.current) {
        event.preventDefault();

        printLock.current = true;

        await handlePrint(
          globalData,
          showAlert,
          billing,
          selectedSize,
          handlePrintSystem,
          setPrint,
          selectTermalOption,
          generateBill1,
          generateInvoice1,
          storeSettings,
          selectedTheme,
          checkNetwork,
          selectHALFA4Option,
          optData,
          isReturnHistory
        );

        // Allow next Enter after print closes
        setTimeout(() => {
          printLock.current = false;
          window.focus();
        }, 1000);
      }
    };

    window.addEventListener("keydown", handleEnterPrint);

    return () => {
      window.removeEventListener("keydown", handleEnterPrint);
    };
  }, [isMainModalOpen, globalData, isActive]);
  useEffect(() => {
    if (storeSettings?.printerSettings?.paperSize) {
      setSelectedSize(storeSettings.printerSettings.paperSize);
    }
  }, [storeSettings]);

   useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(
          globalData,
          showAlert,
          billing,
          selectedSize,
          handlePrintSystem,
          setPrint,
          selectTermalOption,
          generateBill1,
          generateInvoice1,
          storeSettings,
          selectedTheme,
          checkNetwork,
          selectHALFA4Option,
          optData,
          isReturnHistory
        );
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);
  
  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/${isPreSale ? "presale/view" : "sale"}/${saleId}`,
      );
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };
  const handleEdit = async (item) => {

    if (blockedPermissions("SALE:update") || permission === undefined) {
      setEdit(true);
      onClose?.();
      setSaleModalOpen(false);
      setPaymentModal(false);
      try {
        const data = await handleSaleItems(
          isPreSale ? item?.preSaleData?._id : item._id,
        );
        if (data) {
          if (isPreSale) {
            navigate("/editproforma", {
              state: data.preSaleData,
              mode: data.preSaleData.preSaleMode,
            });
          } else if (data.consumeVersion === "CONSUMEV2") {
            navigate("/editsale", { state: data });
          } else {
            navigate("/editsaleold", { state: data });
          }
        }
      } catch (error) {
        console.error("Error loading sale data:", error);
      } finally {
        setEdit(false);
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const projectName =
    globalData?.projectId?.name ?? globalData?.preSaleData?.projectId?.name;

  if (!isOpen) return null;
  return (
    <div className="modal-overlay" style={{ zIndex: 1010 }}>
      <div>
        <div className="modal-backdrop show"></div>

        <div
          className="modal show d-block"
          id="CustomerModal"
          tabIndex="-1"
          aria-modal="true"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-xlg2"
            style={{
              overflowY: "auto",
              height: "calc(100vh - 200px)",
            }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h6 className="modal-title mb-0">
                    {globalData?.salemode
                      ? globalData.salemode
                      : globalData?.preSaleData?.preSaleMode ===
                          "PROFORMA_INVOICE"
                        ? "PROFORMA INVOICE"
                        : globalData.salemode ||
                          globalData?.preSaleData?.preSaleMode}
                  </h6>
                  <div className="d-flex align-items-center fw-bold text-dark mb-0 ">
                    {data.status !== "CANCELLED" &&
                      data.saleTrack !== "RETURNED" &&
                      (edit ? (
                        <button
                          className={`btn${isReturn ? "btn-secondary" : "btn-primary"} my-2 ms-3`}
                          disabled
                        >
                          <CircularProgress size={18} className="text-black" />
                        </button>
                      ) : (
                        <button
                          className={`btn ${isReturn ? "btn-secondary" : "btn-primary"} my-2 ms-3`}
                          onClick={() => handleEdit(data)}
                          disabled={isReturn}
                        >
                          <i className="ng ng-ng-edit-icon fs-15 me-2"></i>
                          Edit
                        </button>
                      ))}
                      {data.status !== "CANCELLED" &&
                      data.saleTrack !== "RETURNED" && !isReturn &&
                      (<>
                        <button
                          className={`btn ${isReturn ? "btn-secondary" : "btn-primary"} my-2 ms-3`}
                          onClick={(e) => {
                                    e.stopPropagation();

                                    navigate("/returnsale", {
                                      state: {
                                        saleId: globalData?.returnSaleData?.saleId || globalData?._id,
                                      },
                                    });
                                  }}
                          disabled={isReturn}
                        >
                          <i className="bx bx-undo fs-20 me-2"></i>
                          Return Sale
                        </button>
                      </>)}
                  </div>
                  {viewOption("saleSettings", "isConvertToInvoice") &&
                    globalData?.salemode === "BILL" &&
                    latestVersion === globalData?.saleVersion &&
                    globalData.status === "ACTIVE" &&
                    (isBtnLoading ? (
                      <button
                        className="btn btn-outline-secondary pb-0 text-right ms-3"
                        disabled
                      >
                        <CircularProgress size={22} className="text-white" />
                      </button>
                    ) : (
                      <button
                        className="btn btn-outline-secondary shadow-none text-right ms-3"
                        onClick={handleModeConfirm}
                      >
                        <i className="bx bx-receipt"></i> To Invoice
                      </button>
                    ))}
                </div>
                {isReturnHistory ? (
                  <span className="gap-2 p-2 bg-label-info rounded-2 d-flex align-items-center">
                    <i className="bx bx-undo font-16"></i>
                    Return Sale History - {data?.returnSaleData?.saleReturnNo}
                    {/* -{" "} */}
                    {/* {data?.returnSaleData?.returnTrack} */}
                    <button
                      type="button"
                      onClick={handleResetSale}
                      className="btn-close custom-close-btn-returnSale"
                      style={{ marginRight: 0 }}
                      aria-label="Close"
                    ></button>
                  </span>
                ) : (
                  <>
                    {(hasModulePermission("SALE") ||
                      permission === undefined) &&
                      (blockedPermissions("SALE:history") ||
                        permission === undefined) && (
                        <div className="d-flex align-items-center">
                          {latestVersion > globalData?.saleVersion && (
                            <span className=" gap-2 p-2 bg-label-warning rounded-2 d-flex align-items-center">
                              <i className="bx bx-show font-16"></i>Sale History
                              - {globalData?.saleno} -{" "}
                              {getSaleTrack(globalData?.saleTrack)} - v
                              {globalData?.saleVersion}
                              <button
                                type="button"
                                onClick={handleResetSale}
                                className="btn-close custom-close-btn-v2"
                                style={{ marginRight: "0px" }}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </span>
                          )}
                        </div>
                      )}
                  </>
                )}
                <div className="d-flex align-items-center gap-1">
                  {projectName && (
                    <>
                      <p className="d-flex align-items-center justify-content-between  badge rounded-pill bg-label-project cursor-poInter mb-0">
                        <span class="me-2">
                          <i class="bi bi-hammer fs-6"></i>
                        </span>
                        {capitalizeFirstLetter(projectName) || "-"}
                      </p>
                      <span className="mx-2 text-muted">|</span>
                    </>
                  )}
                  <p className="small mb-0 ">
                    <b className="tm_primary_color"> Created On:</b>{" "}
                    {createdTime.date} {""}
                    {createdTime.time}
                  </p>
                  <button
                    type="button"
                    onClick={onClose}
                    className="btn-close border ms-1"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
              </div>
              <div className="modal-body d-flex p-0" id="element-to-download">
                {children}
              </div>
             <div className="modal-footer d-flex justify-content-between">
                  <button
                    onClick={onClose}
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-outline-secondary text-left"
                  >
                    <i className="bx bx-x fs-15"></i> Close
                  </button>   
                {!isPurchase &&(
                        <div className="my-2 d-flex gap-2">
                          {share ? (
                            <button className="btn btn-success  pb-0 text-right" disabled>
                              <CircularProgress size={18} className="text-black" />
                            </button>
                          ) : (
                            <button
                              className={`btn ${isReturn ? "btn-secondary" : "btn-primary"}  text-right`}
                              disabled={isReturn}
                              onClick={() => handleNormalShare(data, selectedOption)}
                            >
                              <i className="bx bx-share-alt fs-20"></i>
                            </button>
                          )}
                          {/* {data.status !== "CANCELLED" &&
                            (edit ? (
                              <button className="btn btn-warning pb-0 text-right" disabled>
                                <CircularProgress size={18} className="text-black" />
                              </button>
                            ) : (
                              <button
                                className={`btn ${isReturn ? "btn-secondary" : "btn-primary"} pb-0 text-right`}
                                onClick={() => handleEdit(data)}
                                disabled={isReturn ||data.saleTrack ==="RETURNED"}
                              >
                                <i className="ng ng-ng-edit-icon fs-15"></i>
                              </button>
                            ))} */}
                  
                          {shareLoad ? (
                            <button className="btn btn-success  pb-0 text-right" disabled>
                              <CircularProgress size={18} className="text-black" />
                            </button>
                          ) : (
                            <button
                              className={`btn ${isReturn ? "btn-secondary" : "btn-success"}  text-right`}
                              id="generatebillpdfbtn"
                              disabled={isReturn}
                              onClick={() => handleWhappShare(globalData)}
                            >
                              <i className="bx bxl-whatsapp fs-20"></i>
                            </button>
                          )}
                          {download ? (
                            <button className="btn btn-warning  pb-0 text-right" disabled>
                              <CircularProgress size={18} className="text-black" />
                            </button>
                          ) : (
                            <button
                              className="btn btn-warning  text-right"
                              id="generatebillpdfbtn"
                              onClick={() => handleDownload(data)}
                            >
                              <i className="bx bx-download fs-15"></i>
                            </button>
                          )}
                  
                          <div className="btn-group text-right align-items-center">
                            {print ? (
                              <button className="btn btn-warning  pb-0" disabled>
                                <CircularProgress size={18} className="text-black" />
                              </button>
                            ) : (
                              <>
                                {/* Dropdown toggle */}
                                <button
                                  type="button" // ✅ FIXED
                                  className="btn bg-label-animal shadow-none  dropdown-toggle dropdown-toggle-split"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  style={{ borderRight: "2px solid #fff" }}
                                />
                  
                                <button
                                  onClick={async () => {
                                    handlePrint(
                                      globalData,
                                      showAlert,
                                      billing,
                                      selectedSize,
                                      handlePrintSystem,
                                      setPrint,
                                      selectTermalOption,
                                      generateBill1,
                                      generateInvoice1,
                                      storeSettings,
                                      selectedTheme,
                                      checkNetwork,
                                      selectHALFA4Option,
                                      optData,
                                      isReturnHistory
                                    );
                                  }}
                                  className="btn bg-label-animal shadow-none  rounded-end"
                                  id="printreceiptbtn"
                                >
                                  <i className="bx bx-printer fs-15"></i> Print {selectedSize}
                                </button>
                  
                                {/* Dropdown menu */}
                                <ul className="dropdown-menu dropdown-menu-end">
                                  {sizeOptions.map((opt) => (
                                    <li key={opt.key}>
                                      <button
                                        className={`dropdown-item ${
                                          selectedSize === opt.key ? "active" : ""
                                        }`}
                                        onClick={() => {
                                          setSelectedSize(opt.key);
                                          updatePrinterSetting(opt.key); // 🔥 PATCH API
                                        }}
                                      >
                                        {opt.label}
                                      </button>
                                    </li>
                                  ))}
                                </ul>
                              </>
                            )}
                          </div>
                        </div>
                )}
                      
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvoiceModalLayout;
